import {
    CLOSE_SHOP_THE_LOOK_DIALOG,
    OPEN_SHOP_THE_LOOK_DIALOG,
    FETCH_SHOP_THE_LOOK_PRODUCTS_SUCCESS,
    CONTENT_ROUTE
} from '../actions'
import first from 'lodash/first'

const initialState = {
    open: false,
}

const shopTheLook = (state = initialState, action) => {
    switch (action.type) {
        case OPEN_SHOP_THE_LOOK_DIALOG:
            return {
                ...state,
                open: true,
                title: action.payload.title,
                items: action.payload.items
            }
        case CONTENT_ROUTE:
        case CLOSE_SHOP_THE_LOOK_DIALOG:
            return {
                ...state,
                open: false,
            }
        case FETCH_SHOP_THE_LOOK_PRODUCTS_SUCCESS:
            if (!state.items || !state.items.shopItems) return state.items.shopItems;
            return {
                ...state,
                items: {
                    ...state.items,
                    shopItems: state.items.shopItems.map(item => {
                        const product = first(action.payload.products.filter(product => product.sku === item.sku));
                        if (!product) return item;
                        return {
                            ...item,
                            ...product
                        }
                    })
                }
            }
        default:
            return state
    }
}

export default shopTheLook



// WEBPACK FOOTER //
// ./src/reducers/shopTheLook.js